import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#E5E3DD] mt-24 bg-[#FDFBF7]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 bg-[#702A32] flex items-center justify-center">
              <span className="font-heading text-white text-base leading-none">M</span>
            </div>
            <span className="font-heading text-lg tracking-tight">MapleMarket Canada</span>
          </div>
          <p className="text-sm text-[#5C5A56] font-light max-w-xs leading-relaxed">
            A premium marketplace for Canadian makers, creators, printers and shops.
          </p>
        </div>
        <div>
          <div className="overline mb-3">Discover</div>
          <ul className="space-y-2 text-sm text-[#5C5A56]">
            <li><Link to="/discover" className="hover:text-[#702A32]">All products</Link></li>
            <li><Link to="/stores" className="hover:text-[#702A32]">All stores</Link></li>
            <li><Link to="/discover?type=POD" className="hover:text-[#702A32]">Print-on-demand</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">For sellers</div>
          <ul className="space-y-2 text-sm text-[#5C5A56]">
            <li><Link to="/register" className="hover:text-[#702A32]">Open a store</Link></li>
            <li><Link to="/login" className="hover:text-[#702A32]">Merchant sign in</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Platform</div>
          <ul className="space-y-2 text-sm text-[#5C5A56]">
            <li>About</li>
            <li>Help & FAQ</li>
            <li>Terms · Privacy</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5E3DD] py-6 text-center text-xs text-[#8A8782]">
        © {new Date().getFullYear()} MapleMarket Canada. Made by independent makers across Canada.
      </div>
    </footer>
  );
}
